module.exports = __webpack_public_path__ + "static/media/chas-logo-row.7032fa85.svg";